import { formatMoney } from '../../../../../util/numberUtils';

export const lineTotal = (item) => Number(item.quantity || 0) * Number(item.unit_price || 0);

export const cartTotal = (items = []) => items.reduce((sum, item) => sum + lineTotal(item), 0);

export const formatCartPrice = (currency, amount) => `${currency}${formatMoney(amount)}`.trim();

const errorText = (error) => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  return [
    error.message,
    error.error,
    error.reason,
    typeof error.errors === 'string' ? error.errors : null
  ].filter(Boolean).join(' ');
};

export const cartActionErrorMessage = (error, t, fallbackKey) => {
  const text = errorText(error);
  const stockMatch = text.match(/requested=(\d+)[\s\S]*available=(\d+)/i);

  if (/insufficient stock|CART_INSUFFICIENT_STOCK/i.test(text)) {
    if (stockMatch) {
      return t('cart.playground.stock_error_detail', {
        requested: stockMatch[1],
        available: stockMatch[2]
      });
    }
    return t('cart.playground.stock_error');
  }

  return error?.message || error?.error || t(fallbackKey);
};

